<template>
    <div class="main-container">
        <div class="prompt-heading">
            <div>{{ 'Selected' | trans }}</div>
            <div class="prompt-container">
                <div id="nothing-selected" v-if="this.creatorStudio.settings.prompt_modifier.length === 0">
                    {{ 'Nothing Selected' | trans }}
                </div>

                <div v-for="(option, index) in this.creatorStudio.settings.prompt_modifier" :key="index">
                    <delete-prompt :prompt="option"></delete-prompt>
                </div>
            </div>
        </div>
        <div class="prompt-group-container">
            <div class="prompt-heading" v-for="(prompt, index) in prompts" :key="index">
                <div>{{ prompt.name | trans }}</div>
                <div class="prompt-container">
                    <div v-for="(option, index) in prompt.options" :key="index">
                        <add-prompt :prompt="option"></add-prompt>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PromptEditormanager from '../../manager/PromptEditorManager';
import DeletePrompt from './Elements/DeletePrompt.vue';
import AddPrompt from './Elements/AddPrompt.vue';
import store from '../../mixins/store.mixin';
export default {
    name: 'PromptEditor',
    mixins: [store],
    components: { DeletePrompt, AddPrompt },
    data() {
        return {
            prompts: [],
        };
    },
    created: function () {
        this.prompts = PromptEditormanager.prompts;
    },
    computed: {},
};
</script>
<style scoped>
.main-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.prompt-group-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.prompt-container {
    display: flex;
    gap: 5px;
    flex-wrap: wrap;
}
.prompt-heading {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
#nothing-selected {
    height: 30px;
    color: #6c757d;
    font-weight: 600;
    line-height: 19.07px;
}
</style>
